import type {
  ContentCardContentType,
  ContentCardType
} from '../types';

export const getCardType = (
  itemType: ContentCardType
): ContentCardContentType => {
  if (itemType.includes('video')) {
    return 'video';
  }

  if (itemType.includes('story')) {
    return 'story';
  }

  if (itemType.includes('reel')) {
    return 'reel';
  }

  return 'post';
};
